<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-7 col-md-8 col-sm-12 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">LISTAS</h1>
        </div>
        <div
          class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            v-if="permission('write', 'list')"
            class="btn-add m-1"
            v-on:click="handleModalCreate"
          >
            <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
          </v-btn>
        </div>
      </div>
      <!-- Modal create -->
      <b-modal no-close-on-backdrop size="md" id="createList" hide-footer>
        <template v-slot:modal-title>NOVA LISTA</template>
        <form v-on:submit="create" method="post">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <LabelRequiredField label="TIPO" />
              <select v-model="type" class="form-control">
                <option value="PRODUCT">PRODUTO</option>
              </select>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <LabelRequiredField label="NOME" />
              <input
                type="text"
                ref="autofocus"
                v-model="description"
                class="form-control"
              />
            </div>
            <div class="col-md-12">
              <WarningRequiredFields />
              <ErrorsMessages :errors="errors" />
            </div>
            <div class="col-md-12 text-right">
              <v-btn :disabled="loadingCreate" type="submit" class="btn-save">
                <i class="fas fa-save mr-2 text-twenty"></i>
                {{ loadingCreate ? "CARREGANDO" : "SALVAR" }}
              </v-btn>
            </div>
          </div>
        </form>
      </b-modal>
      <!-- /Modal create -->
      <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 pt-0">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Pesquisar listas"
            outlined
            dense
            @input="paginate"
          />
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <v-data-table
          :headers="headers"
          :items="lists"
          item-key="`${type}`/${id}"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          :options.sync="options"
          :server-items-length="total"
        >
          <template v-slot:[`item.status`]="{ item }">
            {{ item.status == 1 ? "ATIVO" : "INATIVO" }}
          </template>
          <template v-slot:[`item.description`]="{ item }">
            {{ item.description }}
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <small>{{
              item.type == "PRODUCT" ? "PRODUTO" : "MEDICAMENTO"
            }}</small>
          </template>
          <template v-slot:[`item.total_resident_list_items`]="{ item }">
            <small>{{ item.resident_list_item.length }}</small>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small class="btn-edit m-1" @click="handleToList(item)">
              <i class="fas fa-edit mr-2"></i>EDITAR
            </v-btn>
            <v-btn
              small
              class="btn-save m-1"
              @click="$bvModal.show(`residents-${item.id}`)"
            >
              <i class="fas fa-users mr-2"></i>RESIDENTES
            </v-btn>
            <v-btn
              v-if="item.resident_list_item.length > 0"
              small
              class="btn-print m-1"
              @click="$bvModal.show(`release-${item.id}`)"
            >
              <i class="fas fa-print mr-2"></i>RELATÓRIOS
            </v-btn>

            <b-modal
              no-close-on-backdrop
              size="xl"
              :id="`residents-${item.id}`"
              hide-footer
            >
              <template v-slot:modal-title>RESIDENTES</template>
              <div>
                <h1 class="title-pages mb-2 text-center">
                  {{ item.description }}
                </h1>
                <div
                  class="text-center"
                  v-if="item.resident_list_item.length == 0"
                >
                  Nenhum residente cadastrado nesta lista!
                </div>
                <div
                  v-if="item.resident_list_item.length > 0"
                  class="table-responsive"
                >
                  <table class="table table-sm table-striped">
                    <thead>
                      <tr>
                        <th>RESIDENTE</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="resident_list_item in item.resident_list_item"
                        :key="resident_list_item.id"
                      >
                        <td>{{ resident_list_item.name }}</td>
                        <td>
                          <v-btn
                            x-small
                            class="text-twenty btn-print p-1"
                            @click="
                              handleToTable(item.id, 1, resident_list_item.id)
                            "
                          >
                            <i class="fas fa-print mr-2"></i>
                            ESTOQUE ATUAL E PRODUTOS QUE PRECISA COMPRAR
                          </v-btn>
                        </td>
                        <td>
                          <v-btn
                            x-small
                            class="text-twenty btn-print p-1"
                            @click="
                              handleToTable(item.id, 2, resident_list_item.id)
                            "
                          >
                            <i class="fas fa-print mr-2"></i>
                            PRODUTOS QUE PRECISA COMPRAR
                          </v-btn>
                        </td>
                        <td>
                          <v-btn
                            x-small
                            class="text-twenty btn-print p-1"
                            @click="
                              handleToTable(item.id, 3, resident_list_item.id)
                            "
                          >
                            <i class="fas fa-print mr-2"></i>
                            ESTOQUE ATUAL DE PRODUTOS
                          </v-btn>
                        </td>
                        <td>
                          <confirmation-dialog
                            x_small
                            :disabled="loadingDeleteReidentListItem"
                            v-if="permission('remove', 'list')"
                            message-title="EXCLUIR?"
                            message-body="Deseja realmente excluir o residente da tabela?"
                            open-class="btn-delete"
                            open-left-icon="fa-trash"
                            open-text="EXCLUIR"
                            @yes="
                              deleteResidenteListItem(
                                item.id,
                                resident_list_item.id
                              )
                            "
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-modal>

            <b-modal
              centered
              no-close-on-backdrop
              size="md"
              :id="`release-${item.id}`"
              hide-footer
            >
              <template v-slot:modal-title>RELATÓRIOS</template>
              <div class="text-center">
                <h1 class="title-pages mb-2">{{ item.description }}</h1>
                <v-btn
                  class="btn-print btn-block m-1"
                  @click="handleToTable(item.id, 1)"
                >
                  <i class="fas fa-print mr-2"></i> ESTOQUE ATUAL E PRODUTOS QUE
                  PRECISA COMPRAR
                </v-btn>
                <v-btn
                  class="btn-print btn-block m-1"
                  @click="handleToTable(item.id, 2)"
                >
                  <i class="fas fa-print mr-2"></i> PRODUTOS QUE PRECISA COMPRAR
                </v-btn>
                <v-btn
                  class="btn-print btn-block m-1"
                  @click="handleToTable(item.id, 3)"
                >
                  <i class="fas fa-print mr-2"></i> ESTOQUE ATUAL DE PRODUTOS
                </v-btn>
              </div>
            </b-modal>
          </template>
        </v-data-table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import LabelRequiredField from "../templates/Components/LabelRequiredField";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import routes from "../routes";

import toast from "../lib/ToastNotification";

import permission from "../lib/permission";

import { formatDate } from "../lib/format";

export default {
  name: "Lists",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
    ConfirmationDialog,
  },

  data() {
    return {
      total: 0,
      options: {},
      search: "",
      headers: [
        { text: "STATUS", value: "status" },
        { text: "NOME", value: "description" },
        { text: "TIPO", value: "type" },
        { text: "TOTAL DE ITEMS ATIVOS", value: "total_list_items" },
        { text: "TOTAL DE RESIDENTES", value: "total_resident_list_items" },
        { text: "AÇÕES", value: "actions" },
      ],
      lists: [],
      type: "PRODUCT",
      description: "",
      loading: false,
      loadingCreate: false,
      loadingDeleteReidentListItem: false,
      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,

    handleToList({ id }) {
      routes.push({ name: "list", params: { id } });
    },

    handleToTable(id, type, resident_id = null) {
      routes.push({
        name: "list-table",
        params: { id, type },
        query: { resident_id },
      });
    },

    async retrieve() {},

    async paginate() {
      try {
        this.loading = true;

        const { rest_home_id, search } = this;

        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        let params = {
          rest_home_id,
          page,
          itemsPerPage,
          search,
          sortBy,
          sortDesc,
        };

        const response = await api.get("/rest-home/lists/paginate", {
          params,
        });

        const { error, errors, lists, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.lists = lists;
          this.total = total;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { type, description } = this;

        let params = {
          type,
          description,
        };

        const response = await api.post("/rest-home/list", params);

        const { error, errors, message, list_id } = response.data;

        if (!error) {
          this.$bvModal.hide("createList");
          this.paginate();
          toast(message, "success");
          routes.push({ name: "list", params: { id: list_id[0] } });
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteResidenteListItem(list_id, id) {
      try {
        this.loadingDeleteReidentListItem = true;

        let data = { list_id, resident_id: id };

        let response = await api.delete("/rest-home/resident-list-item", {
          data,
        });

        let { error, errors } = response.data;

        if (!error) {
          this.errors = [];
          this.$bvModal.hide(`residents-${list_id}`);
          this.paginate();
        } else {
          this.errors = errors;
        }

        this.loadingDeleteReidentListItem = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleModalCreate() {
      this.type = "PRODUCT";
      this.description = "";
      this.errors = [];
      this.$bvModal.show("createList");
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },
  },
};
</script>
